import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { Group } from 'types/group'
import { deleteGroup } from '@disco/state-management/actions/GroupActions'
import { getGroup } from '@disco/state-management/selectors/groups'
import DocumentHeadTags from 'components/document-head-tags'
import DeleteGroupDialog from 'components/modals/dialogs/delete-group-dialog'

const ChannelDelete = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams<{ channelId: string }>()

  const group = useSelector(state =>
    getGroup(state, {
      groupId: parseInt(params.channelId),
    }),
  )

  const onClose = () => navigate('/')

  const handleDelete = () => {
    dispatch(deleteGroup(group))
    onClose()
  }

  return (
    <div>
      <DocumentHeadTags title="Delete channel" />
      <DeleteGroupDialog
        onConfirm={handleDelete}
        onCancel={onClose}
        group={group}
      />
    </div>
  )
}

export default ChannelDelete
